import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  label?: string;
  options: SelectOption[];
  error?: string;
  onChange?: (value: string) => void;
}
export function Select({
  label,
  options,
  error,
  onChange,
  className = '',
  id,
  value,
  ...props
}: SelectProps) {
  const selectId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-869" data-mp="1hjxj3rp0cgd1">
      {label && <label htmlFor={selectId} className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-870" data-mp="1hgt6q71e2eba">
          {label}
        </label>}
      <div className="relative" data-id="element-871" data-mp="17kq30wqw27m8">
        <select id={selectId} value={value} onChange={e => onChange?.(e.target.value)} className={`
            w-full px-4 py-2.5 pr-10 rounded-lg border appearance-none cursor-pointer
            transition-all duration-200
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-2 focus:ring-red-200' : 'border-gray-300 focus:border-primary-500 focus:ring-2 focus:ring-primary-200'}
            disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed
            ${className}
          `} aria-invalid={error ? 'true' : 'false'} {...props} data-id="element-872" data-mp="17lrgt8zah87n">
          {options.map(option => <option key={option.value} value={option.value} data-id="element-873" data-mp="1am0uhn0fxug0">
              {option.label}
            </option>)}
        </select>
        <ChevronDownIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" data-id="element-874" data-mp="mvncyqfhfdzo" />
      </div>
      {error && <p className="mt-1.5 text-sm text-red-600" role="alert" data-id="element-875" data-mp="vvtoi6rme3w7">
          {error}
        </p>}
    </div>;
}